export const DATA_YOUR_SHORTCUTS = [
  {
    id: 1,
    typeBadge: "success",
    titleBadge: "Success",
    count: 4,
    path: "/lead",
    title: "Lead",
  },
  {
    id: 2,
    typeBadge: "dark",
    titleBadge: "Success",
    count: 4,
    path: "/opportunity",
    title: "Opportunity",
  },
  {
    id: 3,
    typeBadge: "danger",
    titleBadge: "Success",
    count: 4,
    path: "/customer",
    title: "Customer",
  },
  {
    id: 4,
    typeBadge: "info",
    titleBadge: "Success",
    count: 4,
    path: "/sales-analytics",
    title: "Sales Analytics",
  },
  {
    id: 5,
    typeBadge: "warning",
    titleBadge: "Success",
    count: 4,
    path: "/dashboard",
    title: "Dashboard",
  },
];

export const DATABOXTAGS = [
  {
    title: "Sales Pipeline",
    BoxTags: [
      {
        itemBoxTag: "Lead",
        path: "/lead",
      },
      {
        itemBoxTag: "Opportunity",
        path: "/opportunity",
      },
      {
        itemBoxTag: "Customer",
        path: "/customer",
      },
      {
        itemBoxTag: "Contact",
        path: "/contact",
      },
      {
        itemBoxTag: "Communication",
        path: "/communication",
      },
      {
        itemBoxTag: "Lead Source",
        path: "/lead-source",
      },
      {
        itemBoxTag: "Contract",
        path: "/contract",
      },
      {
        itemBoxTag: "Appointment",
        path: "/appointment",
      },
      {
        itemBoxTag: "Newsletter",
        path: "/newsletter",
      },
    ],
  },
  {
    title: "Reports",
    BoxTags: [
      {
        itemBoxTag: "Lead Details",
        path: "/query-report/lead-details",
      },
      {
        itemBoxTag: "Sales Funnel",
        path: "/query-report/sales-funnel",
      },
      {
        itemBoxTag: "Prospects Engaged But Not Converted",
        path: "/query-report/prospects-engaged-but-not-converted",
      },
      {
        itemBoxTag: "First Response Time for Opportunity",
        path: "/query-report/first-response-time-for-opportunity",
      },
      {
        itemBoxTag: "Inactive Customers",
        path: "/query-report/inactive-customers",
      },
      {
        itemBoxTag: "Campaign Efficiency",
        path: "/query-report/campaign-efficiency",
      },
      {
        itemBoxTag: "Lead Owner Efficiency",
        path: "/query-report/lead-owner-efficiency",
      },
    ],
  },
  {
    title: "Maintenance",
    BoxTags: [
      {
        itemBoxTag: "Maintenance Schedule",
        path: "/maintenance-schedule",
      },
      {
        itemBoxTag: "Maintenance Visit",
        path: "/maintenance-visit",
      },
      {
        itemBoxTag: "Warranty Claim",
        path: "/warranty-claim",
      },
    ],
  },
  {
    title: "Campaign",
    BoxTags: [
      {
        itemBoxTag: "Campaign",
        path: "/campaign",
      },
      {
        itemBoxTag: "Email Campaign",
        path: "/email-campaign",
      },
      {
        itemBoxTag: "Social Media Post",
        path: "/social-media-post",
      },
    ],
  },
  {
    title: "Settings",
    BoxTags: [
      {
        itemBoxTag: "Customer Group",
        path: "/customer-group",
      },
      {
        itemBoxTag: "Territory",
        path: "/territory",
      },
      {
        itemBoxTag: "Address",
        path: "/address",
      },
      {
        itemBoxTag: "Sales Person",
        path: "/sales-person",
      },
      {
        itemBoxTag: "SMS Center",
        path: "/sms-center",
      },
      {
        itemBoxTag: "SMS Log",
        path: "/sms-log",
      },
      {
        itemBoxTag: "SMS Settings",
        path: "/sms-settings",
      },
      {
        itemBoxTag: "Email Group",
        path: "/email-group",
      },
      {
        itemBoxTag: "Twitter Settings",
        path: "/twitter-settings",
      },
      {
        itemBoxTag: "LinkedIn Settings",
        path: "/linkedin-settings",
      },
    ],
  },
];

export const DATA_CREATE_SETUP = [
  {
    title: "Let's Set Up Your CRM.",
    description: "Lead, Opportunity, Customer, and more.",
    item: [
      {
        id: 1,
        name: "Introduction to CRM",
        data: {
          title: "Introduction to CRM",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 2,
        name: "Create Lead",
        data: {
          title: "Create Lead",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 3,
        name: "Create Opportunity",
        data: {
          title: "Create Opportunity",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 4,
        name: "Create and Send Quotation",
        data: {
          title: "Create and Send Quotation",
          content: "",
          nameBtn: "Create Entry",
        },
      },
    ],
  },
];

export const DATA_CREATE_SETUP_PAYROLL = [
  {
    title: "Let's Set Up the Payroll Module.",
    description: "Salary, Compensation, and more.",
    item: [
      {
        id: 1,
        name: "Create Employee",
        data: {
          title: "Create Employee",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 2,
        name: "Create Salary Component",
        data: {
          title: "Create Salary Component",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 3,
        name: "Create Payroll Period",
        data: {
          title: "Create Payroll Period",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 4,
        name: "Create Income Tax Slab",
        data: {
          title: "Create Income Tax Slab",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 5,
        name: "Create Salary Structure",
        data: {
          title: "Create Salary Structure",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 6,
        name: "Assign Salary Structure",
        data: {
          title: "Assign Salary Structure",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 7,
        name: "Create Salary Slip",
        data: {
          title: "Create Salary Slip",
          content: "",
          nameBtn: "Create Entry",
        },
      },
      {
        id: 8,
        name: "Payroll Settings",
        data: {
          title: "Payroll Settings",
          content: "",
          nameBtn: "Update Settings",
        },
      },
    ],
  },
];

export const DATA_DROPDOWN_LISTVIEW_CRM = [
  {
    id: 1,
    icon: "bx bx-file",
    name: "Report",
  },
  {
    id: 2,
    icon: "bx bxs-dashboard",
    name: "Dashboard",
  },
  {
    id: 3,
    icon: "bx bxs-layout",
    name: "Kanban",
  },
];
export const DATA_DROPDOWN_MENU_CRM = [
  {
    id: 1,
    name: "Import",
  },
  {
    id: 2,
    name: "User Permissions",
  },
  {
    id: 3,
    name: "Role Permissions Manager",
  },
  {
    id: 4,
    name: "Customize",
  },
  {
    id: 5,
    name: "Toggle Sidebar",
  },
  {
    id: 6,
    name: "Share URL",
  },
  {
    id: 7,
    name: "List Setting",
  },
];

export const DATA_DROPDOWN_GET_ITEMS_FROM = {
  "New Maintenance Schedule": [
    {
      id: 1,
      name: "Sale Order",
    },
  ],
  "New Maintenance Visit": [
    {
      id: 1,
      name: "Maintenance Schedule",
    },
    {
      id: 2,
      name: "Warranty Claim",
    },
    {
      id: 3,
      name: "Sale Order",
    },
  ],
};
export const DATA_DROPDOWN_MENU_MAINTENANCE = {
  "New Maintenance Schedule": [
    {
      id: 1,
      name: "Print",
    },
    {
      id: 2,
      name: "Email",
    },
    {
      id: 3,
      name: "Jump to field",
    },
    {
      id: 4,
      name: "Links",
    },
    {
      id: 5,
      name: "Duplicate",
    },
    {
      id: 6,
      name: "Copy to Clipboard",
    },
    {
      id: 7,
      name: "Reload",
    },
    {
      id: 8,
      name: "Customze",
    },
    {
      id: 9,
      name: "New Maintenance Schedule",
    },
  ],
  "New Maintenance Visit": [
    {
      id: 1,
      name: "Print",
    },
    {
      id: 2,
      name: "Email",
    },
    {
      id: 3,
      name: "Jump to field",
    },
    {
      id: 4,
      name: "Links",
    },
    {
      id: 5,
      name: "Duplicate",
    },
    {
      id: 6,
      name: "Copy to Clipboard",
    },
    {
      id: 7,
      name: "Reload",
    },
    {
      id: 8,
      name: "Customze",
    },
    {
      id: 9,
      name: "New Maintenance Visit",
    },
  ],
};
export const DATA_FILTER_TABLE = [
  {
    id: "lead",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "opportunity",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "customer",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "contact",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "query-report/lead-details",
    isFilterDate: true,
    isFilterSearch: true,
  },
  {
    id: "query-report/sales-funnel",
    isFilterDate: true,
    isFilterSearch: true,
  },
  {
    id: "query-report/prospects-engaged-but-not-converted",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "query-report/first-response-time-for-opportunity",
    isFilterDate: true,
    isFilterSearch: false,
  },
  {
    id: "query-report/inactive-customers",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "query-report/campaign-efficiency",
    isFilterDate: true,
    isFilterSearch: false,
  },
  {
    id: "query-report/lead-owner-efficiency",
    isFilterDate: true,
    isFilterSearch: false,
  },
  {
    id: "maintenance-schedule",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "communication",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "lead-source",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "maintenance-visit",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "contract",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "warranty-claim",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "newsletter",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "sms-log",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "appointment",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "email-group",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "campaign",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "email-campaign",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "social-media-post",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "customer-group",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "territory",
    isFilterDate: false,
    isFilterSearch: true,
  },
  {
    id: "sales-person",
    isFilterDate: false,
    isFilterSearch: true,
  },
];

export const COLUMNS_TABLE = [
  {
    path: "lead",
    columnsPage: [
      {
        dataField: "name",
        text: "Title",
        sort: true,
      },
      {
        dataField: "organizationName",
        text: "Organization Name",
        sort: true,
      },
      {
        dataField: "leadOwner",
        text: "Lead Owner",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "leadId",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "opportunity",
    columnsPage: [
      {
        dataField: "title",
        text: "Title",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "series",
        text: "Series",
        sort: true,
      },
      {
        dataField: "opportunityFrom",
        text: "Opportunity From",
        sort: true,
      },
      {
        dataField: "opportunityType",
        text: "Opportunity Type",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "customer",
    columnsPage: [
      {
        dataField: "name",
        text: "Full Name",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "customerGroup.name",
        text: "Customer Group",
        sort: true,
      },
      {
        dataField: "territory.name",
        text: "Territory",
        sort: true,
      },
    ],
  },
  {
    path: "contact",
    columnsPage: [
      {
        dataField: "emailAddress",
        text: "Email Address",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "phone",
        text: "Phone",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "communication",
    columnsPage: [
      {
        dataField: "subject",
        text: "Subject",
        sort: true,
      },
      {
        dataField: "commentType",
        text: "Comment Type",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "sentOrReceived",
        text: "Sent or Received",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "lead-source",
    columnsPage: [
      {
        dataField: "fullName",
        text: "Name",
        sort: true,
      },
      {
        dataField: "sourceName",
        text: "Source Name",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "contract",
    columnsPage: [
      {
        dataField: "fullName",
        text: "Name",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "fulfilmentStatus",
        text: "Fulfilment Status",
        sort: true,
      },
      {
        dataField: "signedOn",
        text: "Signed On",
        sort: true,
      },
      {
        dataField: "contractTerms",
        text: "Contract Terms",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "newsletter",
    columnsPage: [
      {
        dataField: "subject",
        text: "Subject",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "message",
        text: "Message",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "appointment",
    columnsPage: [
      {
        dataField: "scheduledTime",
        text: "Scheduled Time",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "email",
        text: "Email",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "campaign",
    columnsPage: [
      {
        dataField: "fullName",
        text: "Name",
        sort: true,
      },
      {
        dataField: "description",
        text: "Description",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "email-campaign",
    columnsPage: [
      {
        dataField: "campaign",
        text: "Campaign",
        sort: true,
      },
      {
        dataField: "emailCampaignFor",
        text: "Email Campaign For",
        sort: true,
      },
      {
        dataField: "recipient",
        text: "Recipient",
        sort: true,
      },
      {
        dataField: "startDate",
        text: "Start Date",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "social-media-post",
    columnsPage: [
      {
        dataField: "fullName",
        text: "Name",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "campaign",
        text: "Campaign",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "customer-group",
    columnsPage: [
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
      {
        dataField: "customerGroupName",
        text: "Customer Group Name",
        sort: true,
      },
      {
        dataField: "parentCustomerGroup",
        text: "Parent Customer Group",
        sort: true,
      },
      {
        dataField: "isGroup",
        text: "Is Group",
        sort: true,
      },
    ],
  },
  {
    path: "territory",
    columnsPage: [
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
      {
        dataField: "territoryName",
        text: "Territory Name",
        sort: true,
      },
      {
        dataField: "parentTerritory",
        text: "Parent Territory",
        sort: true,
      },
      {
        dataField: "isGroup",
        text: "Is Group",
        sort: true,
      },
      {
        dataField: "territoryManager",
        text: "Territory Manager",
        sort: true,
      },
    ],
  },
  {
    path: "sales-person",
    columnsPage: [
      {
        dataField: "salesPerson",
        text: "Sales Person Tree",
        sort: true,
      },
    ],
  },
  {
    path: "query-report/lead-details",
    columnsPage: [
      {
        dataField: "lead",
        text: "Lead",
        sort: true,
      },
      {
        dataField: "leadName",
        text: "Lead Name",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "leadOwner",
        text: "Lead Owner",
        sort: true,
      },
      {
        dataField: "territory",
        text: "Territory",
        sort: true,
      },
      {
        dataField: "source",
        text: "Source",
        sort: true,
      },
      {
        dataField: "email",
        text: "Email",
        sort: true,
      },
      {
        dataField: "mobile",
        text: "Mobile",
        sort: true,
      },
      {
        dataField: "phone",
        text: "Phone",
        sort: true,
      },
      {
        dataField: "owner",
        text: "Owner",
        sort: true,
      },
      {
        dataField: "company",
        text: "Company",
        sort: true,
      },
      {
        dataField: "address",
        text: "Address",
        sort: true,
      },
      {
        dataField: "state",
        text: "State",
        sort: true,
      },
      {
        dataField: "postalCode",
        text: "Postal Code",
        sort: true,
      },
      {
        dataField: "country",
        text: "Country",
        sort: true,
      },
    ],
  },
  {
    path: "query-report/sales-funnel",
    columnsPage: [],
  },
  {
    path: "query-report/prospects-engaged-but-not-converted",
    columnsPage: [
      {
        dataField: "lead",
        text: "Lead",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
      {
        dataField: "organization",
        text: "Organization",
        sort: true,
      },
      {
        dataField: "referenceDocumentType",
        text: "Reference Document Type",
        sort: true,
      },
      {
        dataField: "referenceName",
        text: "Reference Name",
        sort: true,
      },
      {
        dataField: "lastCommunication",
        text: "Last Communication",
        sort: true,
      },
      {
        dataField: "lastCommunicationDate",
        text: "Last Communication Date",
        sort: true,
      },
    ],
  },
  {
    path: "query-report/first-response-time-for-opportunity",
    columnsPage: [
      {
        dataField: "creation_date",
        text: "Date",
        sort: true,
      },
      {
        dataField: "firstResponseTime",
        text: "First Response Time",
        sort: true,
      },
    ],
  },
  {
    path: "query-report/inactive-customers",
    columnsPage: [
      {
        dataField: "customerName",
        text: "Customer Name",
        sort: true,
      },
      {
        dataField: "territory",
        text: "Territory",
        sort: true,
      },
      {
        dataField: "customerGroup",
        text: "Customer Group",
        sort: true,
      },
      {
        dataField: "numberOfOrder",
        text: "Number Of Order",
        sort: true,
      },
      {
        dataField: "totalOrderValue",
        text: "Total Order Value",
        sort: true,
      },
      {
        dataField: "totalOrderConsidered",
        text: "Total Order Considered",
        sort: true,
      },
      {
        dataField: "lastOrderAmount",
        text: "Last Order Amount",
        sort: true,
      },
      {
        dataField: "lastOrderDate",
        text: "Last Order Date",
        sort: true,
      },
      {
        dataField: "dateSinceLastOrder",
        text: "Date Since Last Order",
        sort: true,
      },
    ],
  },
  {
    path: "query-report/campaign-efficiency",
    columnsPage: [
      {
        dataField: "campaignName",
        text: "Campaign Name",
        sort: true,
      },
      {
        dataField: "leadCount",
        text: "Lead Count",
        sort: true,
      },
      {
        dataField: "oppCount",
        text: "Opp Count",
        sort: true,
      },
      {
        dataField: "quotCount",
        text: "Quot Count",
        sort: true,
      },
      {
        dataField: "orderCount",
        text: "Order Count",
        sort: true,
      },
      {
        dataField: "orderValue",
        text: "Order Value",
        sort: true,
      },
      {
        dataField: "oppLead",
        text: "Opp/Lead %",
        sort: true,
      },
      {
        dataField: "quotLead",
        text: "Quot/Lead %",
        sort: true,
      },
      {
        dataField: "orderQuot",
        text: "Order/Quot %",
        sort: true,
      },
    ],
  },
  {
    path: "query-report/lead-owner-efficiency",
    columnsPage: [
      {
        dataField: "lead_owner",
        text: "Lead Owner",
        sort: true,
      },
      {
        dataField: "leadCount",
        text: "Lead Count",
        sort: true,
      },
      {
        dataField: "oppCount",
        text: "Opp Count",
        sort: true,
      },
      {
        dataField: "quotCount",
        text: "Quot Count",
        sort: true,
      },
      {
        dataField: "orderCount",
        text: "Order Count",
        sort: true,
      },
      {
        dataField: "orderValue",
        text: "Order Value",
        sort: true,
      },
      {
        dataField: "oppLead",
        text: "Opp/Lead %",
        sort: true,
      },
      {
        dataField: "quotLead",
        text: "Quot/Lead %",
        sort: true,
      },
      {
        dataField: "orderQuot",
        text: "Order/Quot %",
        sort: true,
      },
    ],
  },
  {
    path: "maintenance-schedule",
    columnsPage: [
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "customName",
        text: "Custom Name",
        sort: true,
      },
    ],
  },
  {
    path: "maintenance-visit",
    columnsPage: [
      {
        dataField: "customName",
        text: "Custom Name",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "completionStatus",
        text: "Completion Status",
        sort: true,
      },
      {
        dataField: "maintenanceType",
        text: "Maintenance Type",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "warranty-claim",
    columnsPage: [
      {
        dataField: "customName",
        text: "Custom Name",
        sort: true,
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
      },
      {
        dataField: "itemCode",
        text: "Item Code",
        sort: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
    ],
  },
  {
    path: "sms-log",
    columnsPage: [
      {
        dataField: "senderName",
        text: "Sender Name",
        sort: true,
      },
      {
        dataField: "sentOn",
        text: "Sent On",
        sort: true,
      },
      {
        dataField: "message",
        text: "Message",
        sort: true,
      },
      {
        dataField: "noOfRequestedSms",
        text: "No Of Requested SMS",
        sort: true,
      },
      {
        dataField: "requestedNumbers",
        text: "Requested Numbers",
        sort: true,
      },
      {
        dataField: "noOfSentSms",
        text: "No of Sent SMS",
        sort: true,
      },
      {
        dataField: "sentTo",
        text: "Send To",
        sort: true,
      },
    ],
  },
  {
    path: "email-group",
    columnsPage: [
      {
        dataField: "name",
        text: "Name",
        sort: true,
      },
      {
        dataField: "totalSubscribers",
        text: "Total Subscribers",
        sort: true,
      },
    ],
  },
];

export const DATA_TABLE_COMMON = {
  "Email IDs": [
    {
      dataField: "emailID",
      text: "Email ID",
    },
    {
      dataField: "isPrimary",
      text: "Is Primary",
    },
  ],
  "Contact Numbers": [
    {
      dataField: "number",
      text: "Number",
    },
    {
      dataField: "isPrimaryPhone",
      text: "Is Primary Phone",
    },
    {
      dataField: "isPrimaryMobile",
      text: "Is Primary Mobile",
    },
  ],
  Reference: [
    {
      dataField: "linkDocumentType",
      text: "Link Document Type",
    },
    {
      dataField: "linkName",
      text: "Link Name",
    },
    {
      dataField: "linkTitle",
      text: "Link Title",
    },
  ],
  "New Maintenance Schedule": [
    {
      dataField: "itemCode",
      text: "Item Code",
    },
    {
      dataField: "itemName",
      text: "Item Name",
    },
    {
      dataField: "startDay",
      text: "Start Day",
    },
    {
      dataField: "periodicity",
      text: "Periodicity",
    },
    {
      dataField: "noOfVisits",
      text: "No of Visits",
    },
  ],
  "New Maintenance Visit": [
    {
      dataField: "itemCode",
      text: "Item Code",
    },
    {
      dataField: "itemName",
      text: "Item Name",
      dataField: "contribution",
      text: "Contribution",
    },
    {
      dataField: "contributionToNetTotal",
      text: "Contribution to Net Total",
    },
    {
      dataField: "commissionRate",
      text: "Commission Rate",
    },
    {
      dataField: "incentives",
      text: "Incentives",
    },
  ],
  fulfilmentTerms: [
    {
      dataField: "no",
      text: "No.",
    },
    {
      dataField: "fulfilled",
      text: "Fulfilled",
    },
    {
      dataField: "requirement",
      text: "Requirement",
    },
    {
      dataField: "notes",
      text: "Notes",
    },
  ],
  emailGroup: [
    {
      dataField: "no",
      text: "No.",
    },
    {
      dataField: "emailGroup",
      text: "Email Group",
    },
    {
      dataField: "totalSubscribers",
      text: "Total Subscribers",
    },
  ],
  campaignSchedules: [
    {
      dataField: "no",
      text: "No.",
    },
    {
      dataField: "emailTemplate",
      text: "Email Template",
    },
    {
      dataField: "sendAfter",
      text: "Send After (days)",
    },
  ],
  accounting: [
    {
      dataField: "company",
      text: "Company",
    },
    {
      dataField: "account",
      text: "Account",
    },
  ],
  creditLimit: [
    {
      dataField: "company",
      text: "Company",
    },
    {
      dataField: "creditLimit",
      text: "Credit Limit",
    },
    {
      dataField: "byPass",
      text: "By Pass",
    },
  ],
  salesTeam: [
    {
      dataField: "salesPerson",
      text: "Sales Person",
    },
    {
      dataField: "contribution",
      text: "Contribution (%)",
    },
    {
      dataField: "contributionToNetTotal",
      text: "Contribution to Net Total",
    },
    {
      dataField: "incentives",
      text: "Incentives",
    },
  ],
  "SMS CENTER": [
    {
      dataField: "parameter",
      text: "Parameter",
    },
    {
      dataField: "value",
      text: "Value",
    },
    {
      dataField: "header",
      text: "Header",
    },
  ],
  territoryTargets: [
    {
      dataField: "no",
      text: "No.",
    },
    {
      dataField: "itemGroup",
      text: "Item Group",
    },
    {
      dataField: "fiscalYear",
      text: "Fiscal Year",
    },
    {
      dataField: "targetQty",
      text: "Target Qty",
    },
    {
      dataField: "targetAmount",
      text: "Target Amount",
    },
    {
      dataField: "targetDistribution",
      text: "Target Distribution",
    },
  ],
  links: [
    {
      dataField: "linkDocumentType",
      text: "Link Document Type",
    },
    {
      dataField: "linkName",
      text: "Link Name",
    },
    {
      dataField: "linkTitle",
      text: "Link Title",
    },
  ],
};
export const LEADER_SOURCES = [
  { source: "Walk In" },
  { source: "Campaign" },
  { source: "Customer's Vendor" },
  { source: "Mass Mailing" },
  { source: "Supplier Reference" },
  { source: "Exhibition" },
  { source: "Cold Calling" },
  { source: "Advertisement" },
  { source: "Reference" },
  { source: "Existing Customer" },
  { source: "Create a new Lead Source" },
  { source: "Advanced Search" },
];
export const CAMPAIGN_NAME = [
  { campaign: "Campaign 1" },
  { campaign: "Campaign 2" },
  { campaign: "Campaign 3" },
];
export const CUSTOMERS_OPTIONS = [
  { index: 0, name: "", value: "" },
  { index: 1, name: "Customer 1", value: "Customer 1" },
  { index: 2, name: "Customer 2", value: "Customer 2" },
  { index: 3, name: "Customer 3", value: "Customer 3" },
  { index: 4, name: "Customer 4", value: "Customer 4" },
];
export const STATUS_OPTIONS = [
  { index: 0, name: "", value: "" },
  { index: 1, name: "Lead", value: "lead" },
  { index: 2, name: "Open", value: "open" },
  { index: 3, name: "Replied", value: "replied" },
  { index: 4, name: "Opportunity", value: "opportunity" },
  { index: 5, name: "Quotation", value: "quotation" },
  { index: 6, name: "Lost Quotation", value: "lostQuotation" },
  { index: 7, name: "Interested", value: "interested" },
  { index: 8, name: "Converted", value: "converted" },
  { index: 9, name: "Do Not Contact", value: "non-contact" },
];
export const ADDRESS_TYPES = [
  { index: 0, name: "", value: "" },
  { index: 1, name: "Billing", value: "billing" },
  { index: 2, name: "Shipping", value: "shipping" },
  { index: 3, name: "Office", value: "office" },
  { index: 4, name: "Personal", value: "personal" },
  { index: 5, name: "Plant", value: "plant" },
  { index: 6, name: "Postal", value: "postal" },
  { index: 7, name: "Shop", value: "shop" },
  { index: 8, name: "Subsidiary", value: "subsidiary" },
  { index: 9, name: "Warehouse", value: "warehouse" },
  { index: 10, name: "Current", value: "current" },
  { index: 11, name: "Permanent", value: "permanent" },
  { index: 12, name: "Other", value: "other" },
];
export const LEAD_TYPES = [
  { index: 0, name: "", value: "" },
  { index: 1, name: "Client", value: "client" },
  { index: 2, name: "Channel Partner", value: "channelPartner" },
  { index: 3, name: "Consultant", value: "consultant" },
];
export const REQUEST_TYPES = [
  { index: 0, name: "", value: "" },
  { index: 1, name: "Product Enquiry", value: "productEnquiry" },
  { index: 2, name: "Request for Information", value: "requestInformation" },
  { index: 3, name: "Suggestions", value: "suggestions" },
  { index: 4, name: "Other", value: "other" },
];
export const TITLE_STATUS_CRM = {
  emailGroup: "email-group",
  communication: "communication",
  leadSource: "lead-source",
  appointment: "appointment",
  campaign: "campaign",
  emailCampaign: "email-campaign",
  salesPerson: "sales-person",
  customer: "customer",
};

export const DATA_SALES_PERSON_TREE = [
  {
    id: 1,
    salesPerson: "Rest Of The World",
  },
  {
    id: 2,
    salesPerson: "Vietnam",
  },
];
